import React from "react"
// import { Frame } from "framer"
import products from './products.json'


export default function ProductLine({
    selectProduct
}) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',                
                paddingTop: '2.5rem',                                
                alignItems: 'center',
                justifyContent: 'center'            
            }}
        >
            <div
                style={{
                    width: 'auto'
                }}
            >
                {
                    products.map((product, index) => {
                        return (
                            <div
                                key={index} 
                                background={ "" }                                  
                                style={{         
                                    display: 'inline-block',           
                                    position: 'relative',
                                    width: '5.5rem',
                                    height: '9.75rem',                                                                        
                                }}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => selectProduct(index)}
                            >        
                                <img
                                    src={require(`../assets/${product.thumbnail}`)}
                                    alt={product.id}
                                    style={{
                                        width: '4.5rem',
                                        height: '8.75rem',
                                        padding: '0.5rem'
                                    }}
                                />                        
                            </div>                            
                        )                    
                    })
                }
            </div>
        </div>
    )
}